<template lang="pug">
  .filter-sheet
    y-bottom-sheet(v-model="showSheet" inset scrollable max-width="600px")
      v-card(flat)
        v-card-title.px-4
          div.h6.basic800--text {{ $t('filter_database') }}
          v-spacer
          v-btn(color="white" text @click="clearFilters")
            .button-Aa-small.primary400--text {{ $t('clear_filters') }}
          v-btn(color="textColorAccent" depressed height=32 dark @click="filterData")
            .button-AA-small.basic100--text {{ $t('filter') }}
        v-divider.basic300
        v-card-text.px-4.pb-8
          .status.mt-4
            p.mb-1.label.basic600--text.text-uppercase {{ $t('status') }}
            v-select.mt-2(item-color="basic100" v-model="status" :items="statusSelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
          .custom-label.mt-4
            p.mb-1.label.basic600--text.text-uppercase {{ $t('label') }}
            v-select.mt-2(item-color="basic100" v-model="customLabel" :items="labelSelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
              template(v-slot:item="{ item }")
                v-list-item-content
                  v-list-item-title
                    div.d-flex.align-center
                      v-icon.mr-2(:color="item.value.color") mdi-label
                      div {{ item.text }}
          .salesperson.mt-4(v-if="role === 'Admin'")
            p.mb-1.label.basic600--text.text-uppercase {{ $t('salesperson') }}
            v-combobox.mt-2(v-model="salesperson.name" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down" @click="openMemberFilterDialog = true" readonly type="button" style="text-align-last: left")
          .source.mt-4
            p.mb-1.label.basic600--text.text-uppercase {{ $t('source') }}
            v-combobox.mt-2( v-model="source.name" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down" @click="openFormFilterDialog = true" readonly type="button" style="text-align-last: left")
          .product.mt-4
            p.mb-1.label.basic600--text.text-uppercase {{ $t('product') }}
            v-combobox.mt-2(v-model="product.name" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down" @click="openProductFilterDialog = true" readonly type="button" style="text-align-last: left")
          .status.mt-4
            p.mb-1.label.basic600--text.text-uppercase {{ $t('coupon') }}
            v-select.mt-2(item-color="basic100" v-model="coupon" :items="couponSelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
          .date.mt-4
            div.d-flex
              p.mb-1.label.basic600--text.text-uppercase {{ $t('date') }}
              v-spacer
              p.mb-1.c1.basic600--text(v-if="range.id === 'custom' && selectedDateRange.length > 0")
                template(v-if="selectedDateRange.length > 1") {{ selectedDateRange[0] | humanizeDate }} ~ {{ selectedDateRange[1] | humanizeDate }}
                template(v-else) {{ selectedDateRange[0] | humanizeDate }}
            v-select.mt-2(item-color="basic100" v-model="range" :items="dateRangeSelections" item-text="text" item-value="value" background-color="basic200" height="40" outlined dense hide-details append-icon="mdi-chevron-down")
              template(v-slot:item="{ item }")
                v-list-item-content(v-if="item.value.id === 'custom'" @click="customDateRangePickerDialog = true")
                  v-list-item-title {{ item.text }}
                v-list-item-content(v-else)
                  v-list-item-title {{ item.text }}
                  //- v-list-item-action(v-if="item.value === 'custom'")
                    v-btn.mr-2.black--text(color="black" depressed outlined x-small @click.stop="clickShowFormExample(item.value)") Example


    .modals
      date-range-picker-dialog(:dialog.sync="customDateRangePickerDialog" @selected="dateRangeSelected($event)")
      form-filter-dialog(v-if="openFormFilterDialog" :open.sync="openFormFilterDialog" :company="company" @selected="handleSelectedForm")
      member-filter-dialog(v-if="openMemberFilterDialog" :open.sync="openMemberFilterDialog" :company="company" @selected="handleSelectedMember")
      product-filter-dialog(v-if="openProductFilterDialog" :open.sync="openProductFilterDialog" :company="company" @selected="handleSelectedProduct")

</template>

<script>
import DateRangePickerDialog from './DateRangePickerDialog.vue'
import FormFilterDialog from './FormFilterDialog.vue'
import MemberFilterDialog from './MemberFilterDialog.vue'
import ProductFilterDialog from './ProductFilterDialog.vue'
export default {
  name: 'FilterDatabaseSheet',
  components: { DateRangePickerDialog, FormFilterDialog, MemberFilterDialog, ProductFilterDialog },
  props: ['open', 'company', 'filtered', 'role'],
  data: (vm) => ({
    status: { name: 'All', id: '' },
    customLabel: { name: 'All', color: '#9E9E9E', id: '' },
    salesperson: { name: 'All', id: ''},
    source: { name: 'All', id: '' },
    product: { name: 'All', id: '' },
    range: { name: 'All', id: '' },
    coupon: { name: 'All', id: '' },
    couponSelections: [
      { text: 'All', value: { name: 'All', id: '' } }
    ],
    selectedDateRange: [],
    statusSelections: [
      { text: 'All', value: { name: 'All', id: '' } },
      { text: 'New', value: { name: 'New', id: 'new' } },
      { text: 'Nurture', value: { name: 'Nurture', id: 'follow_up' } },
      { text: 'Partial payment', value: { name: 'Partial payment', id: 'partial_payment' } },
      { text: 'Not Interested', value: { name: 'Not Interested', id: 'reject' } },
      { text: 'Invoice Sent', value: { name: 'Invoice Sent', id: 'processed' } },
      { text: 'Paid', value: { name: 'Paid', id: 'shipped' } },
      { text: 'Scheduled', value: { name: 'Scheduled', id: 'request' } },
      { text: 'Cancelled', value: { name: 'Cancelled', id: 'cancelled' } }
    ],
    dateRangeSelections: [
      { text: 'All', value: { name: 'All', id: '' } },
      { text: vm.$t('today'), value: { name: 'Today', id: 'today' } },
      { text: vm.$t('yesterday'), value: { name: 'Yesterday', id: 'yesterday' } },
      { text: vm.$t('past_7_days'), value: { name: 'Past 7 days', id: 'week' } },
      { text: vm.$t('this_month'), value: { name: 'This month', id: 'month' } },
      { text: vm.$t('this_year'), value: { name: 'This year', id: 'year' } },
      { text: 'Custom', value: { name: 'Custom', id: 'custom' } }
    ],
    labelSelections: [
      { text: 'All', value: { name: 'All', color: '#9E9E9E', id: '' } }
    ],
    openMemberFilterDialog: false,
    openFormFilterDialog: false,
    openProductFilterDialog: false,
    customDateRangePickerDialog: false,
  }),
  computed: {
    showSheet: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  watch: {

  },
  mounted () {
    if (this.filtered.status) {
      this.status = this.filtered.status
    } if (this.filtered.customLabel) {
      this.customLabel = this.filtered.customLabel
    } if (this.filtered.salesperson) {
      this.salesperson = this.filtered.salesperson
    } if (this.filtered.source) {
      this.source = this.filtered.source
    } if (this.filtered.product) {
      this.product = this.filtered.product
    } if (this.filtered.range) {
      this.range = this.filtered.range
    } if (this.filtered.selectedDateRange) {
      this.selectedDateRange = this.filtered.selectedDateRange
    } if (this.filtered.coupon) {
      this.coupon = this.filtered.coupon
    }
    this.fetchRedeemedCoupon()
    this.fetchCustomLabels()
  },
  methods: {
    fetchRedeemedCoupon () {
      this.$axios.get(`/leads/redeemed_coupon_codes/?company=${this.company.id}`)
        .then((response) => {
          this.couponSelections = response.data.map(code => {
            return { text: code, value: { name: code, id: code } }
          })
          this.couponSelections.splice(0, 0, { text: 'All', value: { name: 'All', id: '' } })
          // console.log(this.couponSelections)
        }).catch(() => {})
    },
    fetchCustomLabels () {
      this.$axios.get(`/lead_customlabels?page_size=-1&company=${this.company.id}`)
        .then(resp => {
          if (resp.data && resp.data.results && resp.data.results.length > 0) {
            this.labelSelections = resp.data.results.map(m => { return { text: m.properties.text, value: { name: m.properties.text, color: m.properties.color, id: m.id } } })
            this.labelSelections.splice(0, 0, { text: 'All', value: { name: 'All', color: '#9E9E9E', id: '' } })
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    filterData () {
      let data = {}
      if (this.status.id) {
        data.status = this.status
      }
      if (this.customLabel.id) {
        data.customLabel = this.customLabel
      }
      if (this.salesperson.id) {
        data.salesperson = this.salesperson
      }
      if (this.source.id) {
        data.source = this.source
      }
      if (this.product.id) {
        data.product = this.product
      }
      if (this.range.id) {
        data.range = this.range
        data.selectedDateRange = this.selectedDateRange
      }
      if (this.coupon.id) {
        data.coupon = this.coupon
      }
      this.$emit('filtered', data)
      this.showSheet = false
    },
    clearFilters () {
      this.status = { name: 'All', id: '' }
      this.customLabel = { name: 'All', color: '#9E9E9E', id: '' }
      this.coupon = { name: 'All', id: '' }
      this.salesperson = { name: 'All', id: ''}
      this.source = { name: 'All', id: '' }
      this.product = { name: 'All', id: '' }
      this.range = { name: 'All', id: '' }
      this.selectedDateRange = []
      this.filterData()
    },
    handleSelectedMember (member) {
      this.salesperson = {
        name: member.user.first_name + ' ' + member.user.last_name, id: member.id
      }
    },
    handleSelectedForm (form) {
      this.source = {
        name: form.name, id: form.id
      }
    },
    handleSelectedProduct (product) {
      this.product = {
        name: product.display_name, id: product.id
      }
    },
    dateRangeSelected (dates) {
      this.selectedDateRange = dates
      this.range = { name: 'Custom' , id: 'custom' }
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white;
}
</style>

<i18n>
{
  "en": {
    "filter_database": "Filter database",
    "clear_filters": "Clear filters",
    "filter": "Filter",
    "status": "Status",
    "label": "Label",
    "salesperson": "Salesperson",
    "source": "Source",
    "product": "Product",
    "date": "Date"
  },
  "ms": {
  },
  "id": {
    "filter_database": "Filter database",
    "clear_filters": "Hapus filters",
    "filter": "Filter",
    "status": "Status",
    "label": "Label",
    "salesperson": "Tim jualan",
    "source": "Source",
    "product": "Produk",
    "date": "Tanggal"
  }
}
</i18n>